import React from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import {
  AppBar, Toolbar, Typography, Button, Box, Container, Chip, Stack
} from '@mui/material';
import {
  TrendingUp, Telegram, AdminPanelSettings, Login
} from '@mui/icons-material';
import useStore from '../../store/useStore';

export default function PublicNavbar() {
  const navigate = useNavigate();
  const token = useStore((s) => s.token);
  const user = useStore((s) => s.user);

  return (
    <AppBar
      position="sticky"
      elevation={0}
      sx={{
        backgroundColor: 'rgba(10, 25, 41, 0.95)',
        backdropFilter: 'blur(12px)',
        borderBottom: '1px solid rgba(255, 255, 255, 0.08)',
      }}
    >
      <Container maxWidth="lg">
        <Toolbar disableGutters sx={{ justifyContent: 'space-between', py: 1.5 }}>
          {/* Logo */}
          <Box
            component={RouterLink}
            to="/"
            disableRipple
            sx={{
              display: 'flex',
              alignItems: 'center',
              textDecoration: 'none',
              gap: 1.5,
              color: 'inherit',
            }}
          >
            <Box
              sx={{
                width: 42,
                height: 42,
                borderRadius: '12px',
                background: 'linear-gradient(135deg, #2563eb 0%, #0088cc 100%)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: '0 4px 14px rgba(0, 136, 204, 0.4)',
              }}
            >
              <Telegram sx={{ color: '#fff', fontSize: 26 }} />
            </Box>
            <Box>
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 800,
                  fontSize: '1.25rem',
                  lineHeight: 1.2,
                  background: 'linear-gradient(90deg, #ffffff 0%, #93c5fd 100%)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                }}
              >
                AlphaTrading
              </Typography>
              <Typography
                variant="caption"
                sx={{
                  display: 'block',
                  color: '#94a3b8',
                  fontSize: '0.7rem',
                  letterSpacing: '0.08em',
                  textTransform: 'uppercase',
                  fontWeight: 600,
                }}
              >
                Telegram Alerts Bot
              </Typography>
            </Box>
          </Box>

          {/* Nav Links & Action */}
          <Stack direction="row" spacing={{ xs: 1, sm: 2 }} alignItems="center">
            <Button
              component={RouterLink}
              to="/terms"
              sx={{
                color: '#cbd5e1',
                fontSize: '0.85rem',
                display: { xs: 'none', md: 'inline-flex' },
                '&:hover': { color: '#ffffff' },
              }}
            >
              Terms
            </Button>
            <Button
              component={RouterLink}
              to="/privacy"
              sx={{
                color: '#cbd5e1',
                fontSize: '0.85rem',
                display: { xs: 'none', md: 'inline-flex' },
                '&:hover': { color: '#ffffff' },
              }}
            >
              Privacy
            </Button>
            <Button
              component={RouterLink}
              to="/refund-policy"
              sx={{
                color: '#cbd5e1',
                fontSize: '0.85rem',
                display: { xs: 'none', md: 'inline-flex' },
                '&:hover': { color: '#ffffff' },
              }}
            >
              Refund Policy
            </Button>

            {token && user?.role === 'admin' ? (
              <Button
                component={RouterLink}
                to="/admin/subscribers"
                variant="outlined"
                startIcon={<AdminPanelSettings />}
                sx={{
                  borderColor: 'rgba(255, 255, 255, 0.2)',
                  color: '#93c5fd',
                  borderRadius: 2,
                  fontSize: '0.8rem',
                  '&:hover': { borderColor: '#93c5fd', bgcolor: 'rgba(37,99,235,0.1)' },
                }}
              >
                Admin Area
              </Button>
            ) : token ? (
              <Button
                component={RouterLink}
                to="/my-subscription"
                variant="outlined"
                sx={{
                  borderColor: 'rgba(56, 189, 248, 0.4)',
                  color: '#38bdf8',
                  borderRadius: 2,
                  fontSize: '0.8rem',
                  fontWeight: 700,
                  '&:hover': { borderColor: '#38bdf8', bgcolor: 'rgba(56, 189, 248, 0.1)' },
                }}
              >
                My Subscription
              </Button>
            ) : (
              <Button
                component={RouterLink}
                to="/login"
                startIcon={<Login />}
                sx={{
                  color: '#94a3b8',
                  fontSize: '0.85rem',
                  '&:hover': { color: '#fff' },
                }}
              >
                Login
              </Button>
            )}

            <Button
              component="a"
              href="/#register-section"
              variant="contained"
              startIcon={<Telegram />}
              sx={{
                background: 'linear-gradient(135deg, #0088cc 0%, #006699 100%)',
                color: '#ffffff',
                fontWeight: 700,
                borderRadius: 2.5,
                px: { xs: 1.5, sm: 2.5 },
                py: 0.9,
                fontSize: '0.85rem',
                boxShadow: '0 4px 14px rgba(0, 136, 204, 0.35)',
                '&:hover': {
                  background: 'linear-gradient(135deg, #0099e6 0%, #0077b3 100%)',
                  boxShadow: '0 6px 20px rgba(0, 136, 204, 0.5)',
                },
              }}
            >
              Join ₹1,000/mo
            </Button>
          </Stack>
        </Toolbar>
      </Container>
    </AppBar>
  );
}
